import React from "react";
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Stack,
  Paper,
  Alert,
  MenuItem,
} from "@mui/material";
import { contentRead, contentWrite } from "../../services/content";

const presetFiles = [
  { label: "Products Index", value: "data/products/index.json" },
  { label: "Categories", value: "data/categories/index.json" },
  { label: "Company Info", value: "data/company/index.json" },
  { label: "Certificates Index", value: "data/certificates/index.json" },
  { label: "About (TR)", value: "data/pages/about/tr.json" },
  { label: "About (EN)", value: "data/pages/about/en.json" },
  { label: "Contact Subjects (TR)", value: "data/pages/contact/tr.json" },
  { label: "Contact Subjects (EN)", value: "data/pages/contact/en.json" },
];

const ContentEditor: React.FC = () => {
  const [filePath, setFilePath] = React.useState(presetFiles[0].value);
  const [content, setContent] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState("");

  const loadFile = async () => {
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const result = await contentRead(filePath);
      if (result?.content && result?.encoding === "base64") {
        const decoded = decodeURIComponent(escape(atob(result.content)));
        setContent(decoded);
      } else {
        setContent("");
        setError("Dosya içerik alınamadı");
      }
    } catch (err: any) {
      setError(err?.message || "Yüklenemedi");
    } finally {
      setLoading(false);
    }
  };

  const saveFile = async () => {
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      await contentWrite(
        filePath,
        content,
        message || `chore(content): update ${filePath}`
      );
      setSuccess("Kaydedildi");
    } catch (err: any) {
      setError(err?.message || "Kaydedilemedi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ bgcolor: "#fafafa", minHeight: "100vh", py: 4 }}>
      <Container maxWidth="md">
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 3 }}>
          İçerik Düzenleyici (Geçici)
        </Typography>
        <Paper sx={{ p: 3, borderRadius: 2 }}>
          <Stack spacing={2}>
            {error && <Alert severity="error">{error}</Alert>}
            {success && <Alert severity="success">{success}</Alert>}

            <TextField
              select
              label="Dosya"
              value={filePath}
              onChange={(e) => setFilePath(e.target.value)}
              size="small"
            >
              {presetFiles.map((f) => (
                <MenuItem key={f.value} value={f.value}>
                  {f.label}
                </MenuItem>
              ))}
            </TextField>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <Button variant="outlined" onClick={loadFile} disabled={loading}>
                Yükle
              </Button>
              <Button variant="contained" onClick={saveFile} disabled={loading}>
                Kaydet
              </Button>
              <TextField
                label="Commit Mesajı"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                fullWidth
              />
            </Stack>

            <TextField
              label="JSON İçerik"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              multiline
              minRows={16}
              sx={{ fontFamily: "monospace" }}
            />
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContentEditor;
